import React, { Component } from 'react';
import {Toast, WhiteSpace } from 'antd-mobile';
import axios from "axios";
import url from "url";
import logo from "../assects/img/logo.png";
import storage from "../model/storage";
import "../assects/css/login.css";
class Ylogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginSuccess: false,
      user_phone: "",
      codeDis: false,
      code_num: "获取验证码",
      user_code: "",
      proVal: "",
      cityVal: "",
      jgTxt: '请输入您的姓名',
      phoneJg: false,
      codeJg: false,
      examId: "",
      paperId: "",
      paperInfo: {},
      examTypeId: "",
      btnDis:false,
      examType:"1"
      
    }
  }
 
  componentDidMount() {
    //预留 获取试卷id 和 考试id100000007 45 
    
    let examId = url.parse(this.props.location.search, true).query.examId;
    let paperId = url.parse(this.props.location.search, true).query.paperId;
    //console.log(examId);
    //console.log(paperId);
    if (examId === ""||examId===undefined||paperId === ""||paperId===undefined) {
      Toast.info('获取试卷信息错误!', 1);
      
    }else{
      var that = this;
      that.setState({
        examId: examId,
        paperId:paperId
      })
      storage.set("examId",examId);
      storage.set("paperId",paperId);
      axios.get(storage.baseUrl+'/indexData', {
        params: {
          examId: examId,
          paperId: paperId
        }
      })
        .then(function (response) {
          // debugger
          // handle success
          if(response.data.code!=="0000"&&response.data.code!=="0102"){
            if(response.data.code!=="0001"){
              Toast.info(response.data.message, 2)
            }
            that.setState({
              examTypeId: response.data.examInfo.typeId,
              paperInfo: response.data.paperInfo,
              pro_list: response.data.regnInfos,
              examType:response.data.examInfo.examType,
              btnDis:true,
              codeDis:true
            })
          }else{
            that.setState({
              examTypeId: response.data.examInfo.typeId,
              paperInfo: response.data.paperInfo,
              pro_list: response.data.regnInfos,
              examType:response.data.examInfo.examType
             
            })
          }
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })


    }
  
  }

  
  userPhone = () => {
    this.setState({
      phoneJg: false,
      user_phone: this.refs.phoneVal.value
    })
  }

  ckPhone = () => {
    let myreg = /^(1[3-9])\d{9}$/;
    if (this.state.user_phone === "") {
      this.setState({
        jgTxt: "手机号不能为空，请输入您的手机号",
        phoneJg: true
      })
      return false;
    } else {
      if (!myreg.test(this.state.user_phone)) {
        this.setState({
          jgTxt: "手机号码格式不正确，请重新输入",
          phoneJg: true
        })
        return false;
      } else {
        return true;
      }
    }
  }
  getcode = () => {
    if (this.ckPhone()) {
      var that = this;
      that.setState({
        code_num: "60s",
        codeDis: true

      })
      let code_num = 59;
      let getDao = setInterval(() => {
        if (code_num > 1) {
          this.setState({
            code_num: code_num + "s"
          })
          code_num--;
        } else {
          that.setState({
            code_num: "获取验证码",
            codeDis: false
          })
          clearInterval(getDao);
        }
      }, 1000)

      axios.post(storage.baseUrl+'/sendCode', "mobile=" + that.state.user_phone)
        .then(function (response) {
          // handle success
          //console.log(response.data);
          if (response.data.code !== "0000") {
            
            that.setState({
              jgTxt: response.data.msg,
              codeJg: true,
              code_num: "获取验证码",
              codeDis: false
            })
            clearInterval(getDao);
          } else {
            Toast.info('发送成功', 1);
          }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })

    }


  }
  userCode = (e) => {
    this.setState({
      codeJg: false,
      user_code: e.target.value
    })
  }
  ckCode = () => {
    if (this.state.user_code === "") {
      this.setState({
        jgTxt: "验证码不能为空，请输入您的验证码",
        codeJg: true
      })
      return false;
    } else {
      this.setState({
        jgTxt: "",
        codeJg: false
      })
      return true;
    }
  }
  
 

  login = () => {
    
    if (this.ckPhone() && this.ckCode()) {
      let that=this;
      axios.post(storage.baseUrl+'/loginUserInfo', "&mobile=" + that.state.user_phone + "&code=" 
      + that.state.user_code+"&examTypeId="
      +that.state.examTypeId+"&examId="+that.state.examId+"&paperId="+that.state.paperId
      )
        .then(function (response) {
          // handle success
          //console.log(response.data);
          if (response.data.code !== "0000") {
            if (response.data.code === "0101"||response.data.code === "0102") {
              that.setState({
                jgTxt: response.data.msg,
                codeJg: true
              })
            }else if(response.data.code === "0104"){
              Toast.info('已经答题', 1);
              setTimeout(()=>{
                  that.props.history.push( { pathname: "/Result", state: {examType:that.state.examType,examId:response.data.datas.examId,paperId:response.data.datas.paperId,userId:response.data.datas.userId} });
                 },200);
              }else if(response.data.code === "0107"){
              
               setTimeout(()=>{
                that.props.history.push( { pathname: "/Countdown", state: {examType:that.state.examType,examId:response.data.datas.examId,paperId:response.data.datas.paperId,userId:response.data.datas.userId} });
              },200);
              
            } else if(response.data.code === "0108"){
              that.setState({
                jgTxt: response.data.msg,
                phoneJg: true
              })
             
             
           }else{
              that.setState({
                jgTxt: response.data.msg,
                codeJg: true
              })
            }

            
          } else {
            Toast.info('登录成功', 1);
            storage.set("loginState",true);
            if(that.state.examType==="0"){
              setTimeout(()=>{
                that.props.history.push( { pathname: "/GF", state: {examType:that.state.examType,examId:response.data.datas.examId,paperId:response.data.datas.paperId,userId:response.data.datas.userId} });
             
              },200);
            }else{
              setTimeout(()=>{
                that.props.history.push( { pathname: "/MK", state: {examType:that.state.examType,examId:response.data.datas.examId,paperId:response.data.datas.paperId,userId:response.data.datas.userId} });
             
              },200);
            }
             
          }
        

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })

     

    }

  }
  tologin=()=>{
    
      this.props.history.replace(`/?examId=${this.state.examId}&paperId=${this.state.paperId}`);
  }
   

  render() {   
    return (
      
      <div className="login_con">
        <img src={logo} className="res_logo" alt="logo" />
        <div className="gf_title">{this.state.paperInfo.examName}{this.state.paperInfo.paperName}</div>
        {
          this.state.examType==="0"?
          <p className="gf_tip">(内置详细真题参考答案及解析）</p>:
            <p className="gf_tip">(内置详细参考答案及解析）</p>
        }
        <WhiteSpace size="sm"></WhiteSpace>
        

        <p className="phone_in yy_ct">
          <i></i>
          <input type="text" placeholder='请输入您的电话号码' onChange={this.userPhone} ref="phoneVal" autoFocus maxLength="11" />
          <span className={this.state.phoneJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxt}</span>
        </p>

        <p className="code_in">
          <i></i>
          <input type="text" placeholder='请输入验证码' onChange={this.userCode} ref="codeVal" autoFocus maxLength="6" />
          <button className="get_code" onClick={this.getcode} disabled={this.state.codeDis}>{this.state.code_num}</button>
          <span className={this.state.codeJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxt}</span>
        </p>
      
        <p className="login_tip"><span className="userNum">{this.state.paperInfo.questionsComment}</span></p>
        {
          this.state.examType==="0"?
          <button type="primary" onClick={this.login} className="to_gf" disabled={this.state.btnDis}>立即估分</button>:
          <button type="primary" onClick={this.login} className="to_gf" disabled={this.state.btnDis}>立即模考</button>
        }
        
        <button type="primary" onClick={this.tologin} className="to_yy">未预约</button>
      </div>
    );
  }
}

export default Ylogin;
